import { Day, Days, Hour } from './day';

export class ExternalTooltip {
  constructor() {}

  style() {
    return (
      'background:' +
      'white; border:' +
      '2px solid #dbe2eb; border-width: 1px; padding: 10px; border-radius: 5px'
    );
  }

  square(color: string) {
    return `<div style=" float: left;height: 15px;width: 15px;margin-top: 3px; margin-right: 5px;border: 1px solid black;clear: both; background-color: ${color}; border-color: ${color}; border-radius: 5px;"></div>`;
  }

  requiredSquare() {
    return this.square('rgba(199,204,208, 1)');
  }

  actualSquare() {
    return this.square('rgba(91,141,189, 1)');
  }

  expectedSquare() {
    return this.square('rgba(116,198,232, 1)');
  }

  font() {
    return '';
  }

  getBody = (bodyItem: any) => {
    return bodyItem.lines;
  };

  getTooltipBody(
    actualSquare: string,
    actualResponses: string,
    requireSquare: string,
    requiredResponses: string
  ) {
    return (
      actualSquare +
      '  Actual Completes: ' +
      actualResponses +
      '<br>' +
      requireSquare +
      'Required Completes: ' +
      requiredResponses
    );
  }

  requiredResponse(hour: Hour) {
    return '' + hour.expected;
  }

  actualResponse(hour: Hour) {
    return '' + hour.actual;
  }

  getTime(hour: Hour, day: Day) {
    return `<div> ${hour.hour}-${hour.hour + 1} PST | Day: ${day.day}</div>`;
  }

  getFinalBody(type: string, hour: Hour, day: Day, body: any) {
    if (type == 'bar' && hour.predict) {
      const expectedSquare = this.requiredSquare();
      body =
        this.getTime(hour, day) +
        expectedSquare +
        'Expected Completes: ' +
        hour.expected;
      return body;
    }
    if (type == 'line' && hour.predict) {
      const expectedSquare = this.expectedSquare();
      body =
        this.getTime(hour, day) +
        expectedSquare +
        'Expected Completes: ' +
        hour.expected;
      return body;
    }
    const actualResponses = this.actualResponse(hour);
    const requiredResponses = this.requiredResponse(hour);
    body =
      this.getTime(hour, day) +
      this.getTooltipBody(
        this.actualSquare(),
        actualResponses,
        this.requiredSquare(),
        requiredResponses
      );
    return body;
  }

  justFirstElement<T>(element: Array<T>): Array<T> {
    return element.slice(0, 1);
  }

  render(context: any, days: Days, type: string) {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      tooltipEl.innerHTML = '<table></table>';
      document.body.appendChild(tooltipEl);
    }
    // Hide if no tooltip
    const tooltipModel = context.tooltip;

    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }

    // Set Text
    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map(this.getBody);

      const hour: Hour = days.getHour(titleLines);
      const day: Day = days.getDay(titleLines);
      let innerHtml = '<tbody>';
      this.justFirstElement(bodyLines).forEach((body: any, i: number) => {
        innerHtml +=
          '<tr><td>' +
          '<div style="' +
          this.style() +
          '">' +
          this.getFinalBody(type, hour, day, body) +
          '</div>' +
          '</td></tr>';
      });
      innerHtml += '</tbody>';

      let tableRoot = tooltipEl.querySelector('table') || { innerHTML: '' };
      tableRoot['innerHTML'] = innerHtml;
      // }

      const position = context.chart.canvas.getBoundingClientRect();

      // Display, position, and set styles for font
      tooltipEl.style.opacity = '1';
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.left =
        position.left + tooltipModel.caretX + window.pageXOffset + 10 + 'px';
      tooltipEl.style.top =
        position.top + tooltipModel.caretY + window.pageYOffset + 10 + 'px';
      tooltipEl.style.font = this.font();
      tooltipEl.style.pointerEvents = 'none';
    }
    return tooltipEl;
  }
}
